import React from "react";

import { TestWrapper } from "@ui/Atoms";

import { Props } from "./Button.types";
import * as Styled from "./Button.styled";

export const Button: React.FC<Props> = ({
  children,
  colorType,
  variantStyle,
  size,
  icon,
  iconComponent: Icon,
  testId,
  ...props
}) => {
  const iconExists = !!Icon && !!icon && icon !== "none";

  return (
    <TestWrapper testId={testId}>
      <Styled.Button
        $size={size}
        $style={variantStyle}
        $type={colorType}
        $icon={icon}
        {...props}
      >
        {iconExists && (
          <Styled.IconWrapper className="icon" $icon={icon} $size={size}>
            <Icon />
          </Styled.IconWrapper>
        )}

        {!iconExists && children}
        {iconExists && icon !== "alone" && (
          <span className="label">{children}</span>
        )}
      </Styled.Button>
    </TestWrapper>
  );
};
